import React from 'react';
/**
 * Close icon.
 *
 * @example
 * <CloseIcon />
 */
export default function CloseIcon() {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", width: "18px", height: "18px", viewBox: "0 0 24 24", stroke: "currentColor" },
        React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M6 18L18 6M6 6l12 12" })));
}
//# sourceMappingURL=CloseIcon.js.map